<template>
	<div class='percentage'>
		<h3 class='plot_title'>{{name}}</h3>
		<svg :id='id' class='percentage_viz' width='440px' height='72px'></svg>
		<div class='perc_legend'>
			<div class='legend_icons'>
				<svg class='legend_svg' width='16px' height='56px'>
					<rect width='16' height='16' x='0' y='0' fill='#90EE90'/>
					<rect width='16' height='16' x='0' y='22' fill='#0D256E'/>
					<rect width='16' height='2' x='0' y='52' fill='#87CEEB'/>
				</svg>
			</div>
			<div class='legend_pars'>	
				<p :id='id+"_first_label"' class='legend_p'>prova1</p>				
				<p :id='id+"_second_label"' class='legend_p'>prova2</p>
				<p :id='id+"_mean_label"' class='legend_p'>prova3</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name : 'Percentage', 
	props : [
		'id',
		'name',
		'district'
	],
	mounted() {
		let component = this
		component.draw()
	},
	methods : {
		draw() {
			const name = this.name,
				id = this.id,
				height = 72,
				width = 440

			let dataset = require('/src/assets/final_df.json'),
				district = this.district.replace(' ', '_'),
				tot = dataset[district]['tot_pop'], 
				tot_str = dataset[district]['tot_stran'],
				str_perc = dataset[district]['stran_perc'].toFixed(1),
				mean_str_perc = dataset['mean']['stran_perc'].toFixed(1),
				margin = ({top: 10, right: 20, bottom: 30, left: 20}), 
				perc_h = 48,
				tot_rovigo = 49781

			let svg = d3.select(`#${id}`)

			let x = d3.scaleLinear()
				.domain([0, 100])
				.range([margin.left, width - margin.right - margin.left])

			let percentage = svg.append('g')
				.attr('class', 'perc_group')
				
			percentage
				.append('rect')
				.attr('x', x(0))
				.attr('y', margin.top)
				.attr('height', perc_h)
				.attr('width', x(100))
				.attr('fill', '#0D256E')
				.on('mouseover', function(d,i){
				$(this).attr('fill', '#12349C')
				$(this).attr('cursor', 'pointer')
				})
				.on('mouseout', function(d,i){
				$(this).attr('fill', '#0D256E')
				// $(this).attr('cursor', 'auto')
				$('#tooltip').css('opacity', 0)
				})

			percentage
				.append('rect')
				.attr('x', x(0))
				.attr('y', margin.top)
				.attr('height', perc_h)
				.attr('width', x(str_perc))
				.attr('fill', '#90EE90')
				.on('mouseover', function(d,i){
				$(this).attr('fill', '#bcf5bc')
				$(this).attr('cursor', 'pointer')
				})
				.on('mouseout', function(d,i){
				$(this).attr('fill', '#90EE90')
				// $(this).attr('cursor', 'auto')
				$('#tooltip').css('opacity', 0)
				})

			percentage
				.append('rect')
				.attr('x', x(0) + x(mean_str_perc))
				.attr('y', margin.top)
				.attr('height', perc_h)
				.attr('width', 2)
				.attr('fill', '#87CEEB')

			percentage
				.append('text')
				.attr('x', x(1))
				.attr('y', margin.top + 12 + 1)
				.style('font-size', '10.5px')
				.attr('fill', '#0D256E')
				.text(str_perc + '%')


			$(`#${id}_first_label`).html(tot_str + ' di origine straniera')
			$(`#${id}_second_label`).html(tot + ' italian*')
			$(`#${id}_mean_label`).html('media non italian* di tutti i quartieri: ' + mean_str_perc.toString() + '%')
		}
	}
}
</script>
<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
	.percentage {
		background-color: #FFF;
		padding-bottom: 12px;
		z-index: 2;
	}
	.percentage_viz {
		display: block;
	}
	.perc_legend {
		width: calc(100% - 20px);
		text-align: left;
		margin-left: 20px;
		display: flex;
	}
	.legend_pars {
		margin-left: 4px;
	}
	.legend_pars p {;
		font-size: 12.5px;
		width: calc(400px - 64px);
	}
	.legend_pars p {
		margin-bottom: 7px;
	}
	.legend_pars p:last-child {
		margin-bottom: 0px;
	}
</style>